import { Dialog, DialogContent } from '@material-ui/core';
import { connect, useSelector } from 'react-redux';
import { OpenModal } from '../../../redux/Common/action';
import { CHANGE_PASSWORD_MODAL } from '../../../redux/ModalReducer/actionTypes';
import { RootState } from '../../../redux/store';
import { HarmonisedDialogTitle, HarmonisedModalActions } from '../UI';
import ChangePassword from '../../ChangePassword';

const ChangePasswordModal = ({ OpenModal }) => {
    const modal: any =
        useSelector((store: RootState) => store?.modal?.changePasswordModal) ||
        {};

    const handleClose = () => {
        OpenModal(CHANGE_PASSWORD_MODAL, { isOpen: false });
    };

    return (
        <Dialog
            className="w-100"
            maxWidth={modal?.config?.modalSize || 'xs'}
            fullWidth={modal?.config?.fullWidth || true}
            open={modal?.isOpen || false}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <HarmonisedDialogTitle onClose={handleClose}>
                {modal?.title}
            </HarmonisedDialogTitle>
            <DialogContent>
                <ChangePassword
                    user={modal?.data?.selectedUser}
                    isAdmin={modal?.data?.isAdmin}
                />
            </DialogContent>
            <HarmonisedModalActions
                onCancel={handleClose}
                cancelLabel="Close"
            />
        </Dialog>
    );
};

export default connect(null, {
    OpenModal
})(ChangePasswordModal);
